import { useLang } from '../utils/hooks'
import { langBoardList } from '../assets/langBoardList'

const BoardModify = ({
  board,
  okBoard,
  handleBoardChange,
  handleSave,
  handleCancelModify,
  disabledDemo,
}) => {
  const { lang } = useLang()
  const choosenLang = lang === 'eng' ? langBoardList.eng : langBoardList.fr
  return (
    <>
      <div className="field">
        <div className="control">
          <label className="checkbox">
            <input
              type="checkbox"
              checked={board.active}
              id="active"
              onChange={(e) => handleBoardChange(e)}
            />{' '}
            {choosenLang.board_active_head}
          </label>
        </div>
      </div>
      <div className="field is-horizontal">
        <div className="field-label is-small">
          <label className="label">{choosenLang.board_brand_head}</label>
        </div>
        <div className="field-body">
          <div className="field">
            <div className="control has-icons-right">
              <input
                id="brand"
                className={
                  'input is-small ' +
                  (okBoard.brandOk ? 'is-success' : 'is-danger')
                }
                type="text"
                value={board.brand}
                onChange={(e) => handleBoardChange(e)}
                placeholder="Marque board"
              />
              <span className="icon is-small is-right">
                <i
                  className={
                    'fa ' +
                    (okBoard.brandOk ? 'fa-check' : 'fa-exclamation-triangle')
                  }
                ></i>
              </span>
              {!okBoard.brandOk && (
                <p className="help is-danger">{choosenLang.threeMin}</p>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="field is-horizontal">
        <div className="field-label is-small">
          <label className="label">{choosenLang.board_model_head}</label>
        </div>
        <div className="field-body">
          <div className="field">
            <div className="control has-icons-right">
              <input
                id="model"
                className={
                  'input is-small ' +
                  (okBoard.modelOk ? 'is-success' : 'is-danger')
                }
                type="text"
                value={board.model}
                onChange={(e) => handleBoardChange(e)}
                placeholder="Modèle board"
              />
              <span className="icon is-small is-right">
                <i
                  className={
                    'fa ' +
                    (okBoard.modelOk ? 'fa-check' : 'fa-exclamation-triangle')
                  }
                ></i>
              </span>
              {!okBoard.modelOk && (
                <p className="help is-danger">{choosenLang.twoMin}</p>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="field is-horizontal">
        <div className="field-label is-small">
          <label className="label">{choosenLang.board_year_head}</label>
        </div>
        <div className="field-body">
          <div className="field">
            <div className="control has-icons-right">
              <input
                id="year"
                className={
                  'input is-small ' +
                  (okBoard.yearOk ? 'is-success' : 'is-danger')
                }
                type="number"
                value={board.year}
                onChange={(e) => handleBoardChange(e)}
                placeholder="Année board"
              />
              <span className="icon is-small is-right">
                <i
                  className={
                    'fa ' +
                    (okBoard.yearOk ? 'fa-check' : 'fa-exclamation-triangle')
                  }
                ></i>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="field is-horizontal">
        <div className="field-label is-small">
          <label className="label">{choosenLang.board_volume_head}</label>
        </div>
        <div className="field-body">
          <div className="field">
            <div className="control has-icons-right">
              <input
                id="volume"
                className={
                  'input is-small ' +
                  (okBoard.volumeOk ? 'is-success' : 'is-danger')
                }
                type="number"
                value={board.volume}
                onChange={(e) => handleBoardChange(e)}
                placeholder="Volume board"
              />
              <span className="icon is-small is-right">
                <i
                  className={
                    'fa ' +
                    (okBoard.volumeOk ? 'fa-check' : 'fa-exclamation-triangle')
                  }
                ></i>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="field is-grouped">
        <div className="control">
          <button
            className="button is-link"
            disabled={
              !okBoard.brandOk ||
              !okBoard.modelOk ||
              !okBoard.yearOk ||
              !okBoard.volumeOk ||
              disabledDemo
            }
            onClick={handleSave}
            title={disabledDemo ? choosenLang.registeredOnly : ''}
          >
            {choosenLang.save}
          </button>
        </div>
        <div className="control">
          <button
            className="button is-link is-light"
            onClick={handleCancelModify}
          >
            {choosenLang.cancel}
          </button>
        </div>
      </div>
    </>
  )
}

export default BoardModify
